<script setup>
import { ref, computed, nextTick, onBeforeUnmount, onMounted } from 'vue';
import { useTriviaStore } from '@/stores/trivia.js';
import { v4 as guid } from 'uuid';
import { BsTrashFill } from "@kalimahapps/vue-icons";

const store = useTriviaStore();
const teams = computed({
  get() {
    return store.CurrentGame.scoreboard.slice().sort((a, b) => a.ranking.rank - b.ranking.rank);
  },
  set(newTeams) {
    store.CurrentGame.scoreboard = newTeams;
  }
});
const highlightedTeam = ref(null);
const editTeam = ref(null);
const editScore = ref(null);
const emit = defineEmits(['close']);

function renameTeam(teamId) {
  const team = store.CurrentGame.scoreboard.find((team) => team._id === teamId);
  const newName = prompt('Enter new team name:', team.name);
  if (newName) {
    team.name = newName;
  }
  store.setTeam(team);
}


function addTeam() {
  const teamName = prompt('Enter team name:');
  store.addTeam(teamName);
  // const newTeamId = guid();
  // const randomColor = teamColors[Math.floor(Math.random() * teamColors.length)];
  // store.CurrentGame.scoreboard.push({
  //   _id: newTeamId,
  //   name: '',
  //   score: 0,
  //   toAdd: 0,
  //   order: teams.value.length + 1,
  //   ranking: {
  //     tie: false,
  //     rank: teams.value.length + 1,
  //   },
  //   color: randomColor,
  // });
  // editTeam.value = newTeamId;
  // await nextTick();
  // document.getElementById(`teamEntry-${newTeamId}`).focus();
  // updateScoreboard();
}

function deleteTeam(teamId) {
  const index = store.CurrentGame.scoreboard.findIndex((team) => team._id === teamId);
  store.CurrentGame.scoreboard.splice(index, 1);
  updateScoreboard();
}

onMounted(() => {
  // If there are no teams, create an empty array
  if (!teams.value) store.CurrentGame.scoreboard = [];
});

const teamColors = [
  // ... (rest of your teamColors array)
];

const modifierKeys = [];

function teamClasses(team) {
  const teamStyle = {
    backgroundColor: team.color && team.color.background ? team.color.background : 'white',
    color: team.color && team.color.color ? team.color.color : 'black',
  };
  if (teams.value.length > 10) {
    teamStyle.margin = '0px';
    teamStyle.padding = '5px';
    teamStyle.fontSize = '1.5em';
  }
  return {
    class: {
      highlighted: editTeam.value === team._id,
      'team__item--editing-score-positive': team.toAdd > 0,
      'team__item--editing-score': editScore.value === team._id,
      'team__item--editing-score-negative': team.toAdd < 0,
    },
    style: teamStyle,
  }
}

async function keydownHandler(e) {
  const shift = modifierKeys.includes('Shift');
  switch (e.key) {
    case('ArrowUp'): {
      const index = teams.value.findIndex((team) => team._id === editScore.value);
      if (modifierKeys.includes('Control') && teams.value[index]) {
        const randomStyle = store.themes[Math.floor(Math.random() * store.themes.length)];
        teams.value[index].color = randomStyle;
      } else if (editScore.value && teams.value[index]) {
        teams.value[index].toAdd = Number(teams.value[index].toAdd) + (shift ? 5 : 1);
      }
      break;
    }
    case('ArrowDown'): {
      const index = teams.value.findIndex((team) => team._id === editScore.value);
      if (modifierKeys.includes('Control') && teams.value[index]) {
        const newIndex = (teamColors.findIndex((color) => color.background === teams.value[index].color.background) - 1) % teamColors.length || teamColors.length - 1;
        teams.value[index].color = teamColors[newIndex];
      } else if (editScore.value && teams.value[index]) {
        teams.value[index].toAdd = Number(teams.value[index].toAdd) - (shift ? 5 : 1);
      }
      break;
    }
    case('ArrowLeft'): {
      let currentIndex;
      if (!editScore.value) {
        editScore.value = teams.value[0]._id;
        currentIndex = 0;
      } else {
        currentIndex = teams.value.findIndex((team) => team._id === editScore.value);
        if (teams.value[currentIndex - 1]) {
          // If exists, go to previous team
          editScore.value = teams.value[currentIndex - 1]._id;
        } else {
          // Otherwise, go to last team
          editScore.value = teams.value[teams.value.length - 1]._id;
        }
      }
      break;
    }
    case('ArrowRight'): {
      let currentIndex;
      if (!editScore.value) {
        editScore.value = teams.value[0]._id;
        currentIndex = 0;
      } else {
        currentIndex = teams.value.findIndex((team) => team._id === editScore.value);
        if (teams.value[currentIndex + 1]) {
          // If exists, go to next team
          editScore.value = teams.value[currentIndex + 1]._id;
        } else {
          // Otherwise, go back to beginning
          editScore.value = teams.value[0]._id;
        }
      }
      break;
    }
    case ('Enter'): {
      if (editTeam.value) {
        document.getElementById(`teamEntry-${editTeam.value}`).blur();
        editTeam.value = null;
      }
      if (editScore.value) {
        let maxTimer = 0;
        teams.value.forEach((team) => {
          let timer = 0;
          for (let i = 0; i < Math.abs(team.toAdd); i += 1) {
            setTimeout(() => {
              if (team.toAdd > 0) {
                team.toAdd = Number(team.toAdd) - 1;
                team.score = Number(team.score) + 1;
              }
              if (team.toAdd < 0) {
                team.toAdd = Number(team.toAdd) + 1;
                team.score = Number(team.score) - 1;
              }
            }, timer);
            timer += 250;
            setTimeout(() => {
              store.setScores();
            }, timer + 10);
            if (timer > maxTimer) maxTimer = timer;
          }
        });
        editScore.value = null;
        setTimeout(() => {
          store.setScores();
        }, maxTimer);
      }
      break;
    }
    case('`'):
    case('Escape'): {
      if (!editTeam.value && !editScore.value) {
        emit('close');
      }
      editTeam.value = null;
      editScore.value = null;
      break;
    }
    case('Shift'): {
      modifierKeys.push(e.key);
      break;
    }
    case('Control'): {
      modifierKeys.push(e.key);
      break;
    }
    case('Delete'):
    case('Backspace'): {
      if (!editTeam.value && editScore.value) {
        const index = teams.value.findIndex((team) => team._id === editScore.value);
        teams.value.splice(index, 1);
      }
      break;
    }
  }
  updateScoreboard();
}

async function keyupHandler(e) {
  switch (e.key) {
    case('Control'):
    case('Shift'): {
      modifierKeys.splice(modifierKeys.indexOf(e.key), 1);
      break;
    }
    case(' '): {
      if (!editTeam.value && !editScore.value) {
        addTeam();
      }
      if (!editTeam.value && editScore.value) {
        editTeam.value = editScore.value;
        await nextTick();
        document.getElementById(`teamEntry-${editTeam.value}`).focus();
      }
      break;
    }
  }
}

onMounted(() => {
  document.addEventListener('keydown', keydownHandler);
  document.addEventListener('keyup', keyupHandler);
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', keydownHandler);
  document.removeEventListener('keyup', keyupHandler);
});

async function selectTeam(teamId) {
  editTeam.value = teamId;
  await nextTick();
  if (document.getElementById(`teamEntry-${teamId}`)) document.getElementById(`teamEntry-${teamId}`).focus()
}

function updateScoreboard() {
  if (teams.value) {
    store.updateScoreboard(teams.value);
  }
}

function resetScoreboard() {
  store.CurrentGame.scoreboard.splice(0, store.CurrentGame.scoreboard.length);
  updateScoreboard();
}

function teamRanking(ranking) {
  if (!ranking) return '';
  // Determine suffix for ranking (1st, 2nd, 3rd, etc.)
  let suffix = 'th';
  if (ranking.rank % 10 == 1 && ranking.rank % 100 != 11) {
    suffix = 'st';
  } else if (ranking.rank % 10 == 2 && ranking.rank % 100 != 12) {
    suffix = 'nd';
  } else if (ranking.rank % 10 == 3 && ranking.rank % 100 != 13) {
    suffix = 'rd';
  }
  if (ranking.tie) {
    return `${ranking.rank}${suffix} (Tie) `;
  }
  return `${ranking.rank}${suffix} `;
}

</script>

<template>
  <div
      id="leaderboard">
    <span
        class="leaderboard-header">
        Leaderboard
    </span>
    <TransitionGroup
        name="list"
        tag="ul"
        class="team"
        :class="{ 'two-columns': teams && teams.length > 6 }">
      <li
          v-for="team in teams"
          :key="team._id"
          class="team__item"
          :class="teamClasses(team).class"
          :style="teamClasses(team).style"
          @click="selectTeam(team._id)">
        <div
            v-if="editTeam === team._id">
          <button
              :id="`team-delete-${team._id}`"
              @click="deleteTeam(team._id)">
            <BsTrashFill />
          </button>
          <input
              :id="`teamEntry-${team._id}`"
              v-model="team.name"
          />
        </div>
        <div
            v-else
                class="team__score__container">
            <span
                v-text="teamRanking(team.ranking)"
                class="team__ranking"
            />
            <span
                @click="renameTeam(team._id)"
                v-text="team.name"
                class="team__name"
            />
            <span
                v-if="team.toAdd !== 0"
                @click="editScore === team._id ? editScore = null : editScore = team._id"
                v-text="` ${team.toAdd === 0 || team.toAdd > 0 ? '+' : ''} ${team.toAdd}`"
                class="team__score__toAdd"
          />
          <span
              @click="editScore === team._id ? editScore = null : editScore = team._id"
              v-text="team.score"
              class="team__score"
          />
        </div>
      </li>
    </TransitionGroup>
    <button
        id="resetScoreboard"
        @click="resetScoreboard()">
      Reset
    </button>
    <button
        id="closeScoreboard"
        @click="emit('close')">
      Close
    </button>
    <!--<button
        id="addTeam"
        class="mr-5 ml-5"
        @click="addTeam()">
      Add Team
    </button> -->
  </div>
</template>

<style scoped lang="scss">
  #leaderboard {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    cursor: default;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: 'Arial', sans-serif;
    background-color: #333;
    text-align: center;
    padding: 3vmax 8vmax;
  }
  .team {
    transition: order 0.5s ease;
    list-style: none;
    &__item {
      -webkit-user-select: none; /* Safari */
      -ms-user-select: none; /* IE 10 and IE 11 */
      user-select: none; /* Standard syntax */
      background: linear-gradient(to bottom right, rgba(#fff, 0), rgba(#fff, 0.5));
      box-sizing: border-box;
      min-width: 44vw;
      width: 44vw;
      font-size: 2.5em;
      border: 1px solid #ddd;
      padding: 10px;
      margin-bottom: 10px;
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 5px solid rgba(darkslategrey, 0.3);
      &--editing-score {
        border: 5px solid skyblue;
        &-positive {
          color: green;
        }
        &-negative {
          color: red;
        }
      }
    }
    &__ranking {
      font-size: 0.8em;
      font-weight: bold;
    }
    &__name {
      font-size: 1.2em;
      margin-left: 15px;
    }
    &__score {
      &__toAdd {
        font-size: 1.2em;
        margin: 0 auto;
      }
      &__container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }
      margin-left: auto;
      margin-right: 20px;
      font-size: 1.5em;
      font-weight: bold;
    }
  }

// Animation for rearranging team list
.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 2.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
}
/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}


.leaderboard-header {
  font-size: 4.5em;
  font-weight: bold;
  background-image: linear-gradient(to right, gold, lighten(gold, 25%), gold, lighten(gold, 25%));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-align: center;
  text-shadow: 2px 2px 40px #fff;
  position: relative;
}

@keyframes pulse {
    0% { text-shadow: 2px 2px 4px rgba(#fff,0.3); }
    50% { text-shadow: 2px 2px 8px rgba(#fff,0.5); }
    100% { text-shadow: 2px 2px 4px rgba(#fff,0.3); }
}

.leaderboard-header {
    animation: pulse 5s infinite ease-in-out;
}

.highlighted {
  border: 5px solid skyblue;
}

#resetScoreboard {
  background-color: darkslategrey;
  border: none;
  padding: 10px;
  border-radius: 5px;
  font-size: 1em;
  color: red;
  cursor: pointer;
  display: inline-block;
  position: absolute;
  top: 0;
  left: 75px;
  &:hover {
    background-color: red;
    color: white;
  }
}
#closeScoreboard {
  background-color: darkslategrey;
  border: none;
  padding: 10px;
  border-radius: 5px;
  font-size: 1em;
  color: white;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  &:hover {
    background-color: lighten(darkslategrey, 20%);
  }
}

.two-columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
</style>
